// extracted by mini-css-extract-plugin
export default {"contractCard":"styles_contractCard__tA+1H","iconBox":"styles_iconBox__5RQ8u","content":"styles_content__qafm4","group":"styles_group__WPBRE","roomName":"styles_roomName__ALSAD"};